import { notices } from '../requests/notices'
import { validation } from '../requests/validation'

class Autofill {
    init() {
        this.input = document.querySelector('input#vat')
        this.button = document.querySelector('button[data-action="autofill"]')
        this.select = document.querySelector('select#country')
        if (!this.input || !this.button || !this.select) return
        
        this.eventHandler()
    }

    eventHandler() {
        this.button.addEventListener('click', (e) => {
            notices.hideNotices()
            var notice = notices.getNotice(this.input.form)

            if (!this.input.value) {
                notices.showErrorNotice(notice, window.Translations['error.noVat'])
            } else {
                this.updatePartial(this.select.value, this.input.value, this.input.form)
            }
        })

        // this.select.addEventListener('change', (e) => {
        //     // console.log(e.currentTarget.value)
        // })
    }

    async updatePartial(country, vatNumber, form) {
        var action = '_company-api/default/partial'

        var form = document.createElement('form')
        form.setAttribute('method', 'post')

        var input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', 'CRAFT_CSRF_TOKEN')
        input.setAttribute('value', window.Craft.csrfTokenValue)
        form.appendChild(input)

        var input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', 'action')
        input.setAttribute('value', action)
        form.appendChild(input)

        var input = document.createElement('input')
        input.setAttribute('type', 'text')
        input.setAttribute('name', 'country')
        input.setAttribute('value', country)
        form.appendChild(input)

        var input = document.createElement('input')
        input.setAttribute('type', 'text')
        input.setAttribute('name', 'vatNumber')
        input.setAttribute('value', vatNumber)
        form.appendChild(input)

        var input = document.createElement('input')
        input.setAttribute('type', 'text')
        input.setAttribute('name', 'path')
        input.setAttribute('value', '_partials')
        form.appendChild(input)

        var input = document.createElement('input')
        input.setAttribute('type', 'text')
        input.setAttribute('name', 'template')
        input.setAttribute('value', 'companies')
        form.appendChild(input)

        var data = new FormData(form)
        var results = document.querySelector('[data-partial="companies"]')
        var notice = results.querySelector('[data-field="notice"]')

        var loader = document.querySelector('[data-loader]')
        loader.classList.remove('js-hidden')
        results.innerHTML = ''

        return fetch('', {
            method: 'POST',
            body: data
        })
        .then(response => response.json())
        .then(data => {
            // console.log('fetch data: ', data)
            if (typeof data.errors !== 'undefined' && data.errors) return
            loader.classList.add('js-hidden')
            results.innerHTML = data.partial
            this.autofill(data.variables.data)
        })
        .catch(error => {
            console.log('fetch error: ', error)
            loader.classList.add('js-hidden')
            notices.showErrorNotice(notice, window.Translations['error.fetch'])
        })
    }

    autofill(data) {
        var results = document.querySelector('[data-partial="companies"]')
        results.addEventListener('click', (e) => {
            if(e.target.tagName === 'BUTTON' && e.target.getAttribute('data-action') == 'select') {
                var companyName = document.querySelector('input#companyName')
                var vatNumber = document.querySelector('input#vatNumber')
                var addressStreet = document.querySelector('input#addressStreet')
                var addressNumber = document.querySelector('input#addressNumber')
                var addressPostalCode = document.querySelector('input#addressPostalCode')
                var addressCity = document.querySelector('input#addressCity')
                var addressCountry = document.querySelector('select#addressCountry')

                addressCountry.value = data.country_code
                companyName.value = data.trader_name
                vatNumber.value = data.country_code + data.vat_number
                addressStreet.value = data.trader_address_components.street
                addressNumber.value = data.trader_address_components.street_number
                addressPostalCode.value = data.trader_address_components.postal_code
                addressCity.value = data.trader_address_components.city
            }
            
            var fields = []
            fields.push(companyName, vatNumber, addressStreet, addressNumber, addressPostalCode, addressCity, addressCountry)
            validation.autofillListener(fields)
        })
    }
}

export const autofill = new Autofill()